// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getFiles,
    uploadFile
} from '../../../product/shared/repositories';
import actions from '../../action-list';
import {errorAlertBar} from '../../../shared/services/alert-bar';
import {getFile} from '../../../shared/repositories';

export const copyAttachments = (claim, tempObjectKey, claimType) =>
    async dispatch => {

        dispatch({
            isCopied: false,
            type: actions[`UPDATE_CLAIM_${claimType}_IS_COPIED`]
        });

        dispatch({
            files: [],
            type: actions[`UPDATE_CLAIM_${claimType}_FILE_LIST`]
        });

        try {

            dispatch(busyCounter.increaseBusyCounter());

            let recentFile;

            // download each file from the old claim and upload to the new claim

            if (claim.file.length) {

                /* eslint-disable babel/no-await-in-loop, max-depth */

                for (const fileObj of claim.file) {

                    const response = await getFile(fileObj);
                    const blob = await response.blob();
                    const file = new File([blob], fileObj.fileName, {type: blob.type});

                    fileObj.objectKey = tempObjectKey;
                    fileObj.classType = 'OT';

                    const formData = new FormData();

                    formData.append('file', file, fileObj.fileName);

                    await uploadFile(fileObj, formData);

                    recentFile = fileObj;

                }

                const files = await getFiles(recentFile);

                dispatch({
                    files,
                    type: actions[`UPDATE_CLAIM_${claimType}_FILE_LIST`]
                });

                /* eslint-enable babel/no-await-in-loop, max-depth */

            }

        } catch (error) {

            const errorObject = {
                isTranslated: false,
                message: 'UNABLE_TO_COPY_ATTACHMENTS'
            };

            errorAlertBar(errorObject);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/copy-attachment.js